import React, { Component } from 'react';
import { StyleSheet, View, Text } from 'react-native';

class Faq extends Component {
    render() {
        return (
            <View>
                <Text style={styles.text}>
                    {
                        "1. Any difference between Create Entity, Save Entity and Update Entity?"
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "We use the same web service. M18 check if there exist same code to decide it is a create action or an update action. "
                    }
                </Text>
            </View>
        )
    }
}

const styles = StyleSheet.create({
    text: {
        paddingTop: 20,
    },
});

export default Faq;



// WEBPACK FOOTER //
// ./src/pages/ch5/Faq.js